import styles from "@css/modules/pointsGuide.module.scss"
import { useState } from "react"
import cn from "classnames"
import { Step3Icon1 } from "./step-icons/Step3Icon1"
import { Step3Icon2 } from "./step-icons/Step3Icon2"
import { Step3Icon3 } from "./step-icons/Step3Icon3"
import { Step3Icon4 } from "./step-icons/Step3Icon4"
import { Step3Icon5 } from "./step-icons/Step3Icon5"
import { RadioButtons } from "@components/RadioButtons"
import { yesNoItems } from "./utils/utils"

const list = [
    {
        icon: Step3Icon1,
        text: "Flexible"
    },
    {
        icon: Step3Icon2,
        text: "Spring",
        members: "Mar - Apr - May"
    },
    {
        icon: Step3Icon3,
        text: "Summer",
        members: "Jun - Jul - Aug"
    },
    {
        icon: Step3Icon4,
        text: "Autumn",
        members: "Sep - Oct - Nov"
    },
    {
        icon: Step3Icon5,
        text: "Winter",
        members: "Dec - Jan - Feb"
    }
]
const isToggleVisible = (value) => {
    return value.size > 1 || (value.size === 1 && !value.has(2))
}

export function Step3({ onChange, goNext, goBack, lastValue }) {
    const [value, setValue] = useState(() => new Map(lastValue?.values))
    const [multiplier, setMultiplier] = useState(() => lastValue?.multiplierVal)
    const [toggleVisible, setToggleVisible] = useState(() => {
        return isToggleVisible(value)
    })
    const localSetValue = (val, index) => {
        if (value.has(index)) {
            value.delete(index)
        } else {
            value.set(index, val)
        }

        const holidays = isToggleVisible(value)
        setToggleVisible(holidays)
        if (!holidays) {
            setMultiplier(undefined)
        }
        setValue(value)
        onChange({
            values: value,
            multiplierVal: multiplier,
            multiplier: holidays && multiplier === "yes"
        })
    }
    const onGoNext = () => {
        if (value) {
            goNext()
        }
    }
    const onChangeToggle = (event) => {
        setMultiplier(event.target.value)
        onChange({
            values: value,
            multiplierVal: event.target.value,
            multiplier: event.target.value === "yes"
        })
    }
    return (
        <div className={styles.stepContainer}>
            <div className={styles.stepContent} id="scroll-target">
                <h2>When do you typically like to vacation?</h2>
                <div className={styles.stepIcons}>
                    {list.map((i, index) => {
                        const Icon = i.icon
                        return (
                            <button
                                key={index}
                                className={cn({
                                    [styles.step3IconBtn]: true,
                                    [styles.stepIconBtn]: true,
                                    [styles.stepIconBtnActive]: value.has(index)
                                })}
                                onClick={() => localSetValue(i, index)}>
                                <Icon />
                                <div className={styles.btnContent}>
                                    <div className={styles.stepIconText}>{i.text}</div>
                                    <div className={styles.stepIconSub}>{i.members}</div>
                                </div>
                            </button>
                        )
                    })}
                </div>
                {toggleVisible && (
                    <div className={styles.yesNo3Wrapper}>
                        <div className={styles.toggleLabel}>Do you plan to vacation over any of the following holidays; Christmas, New Years, Thanksgiving, Spring Break?</div>
                        <RadioButtons items={yesNoItems} name="yesNo" onChange={onChangeToggle} defaultValue={multiplier} classes={{ label: styles.yesNo3Label }} />
                    </div>
                )}

                <div className={styles.overBackNext}>
                    <button className={styles.goBack} onClick={goBack}>
                        Back
                    </button>
                    <button disabled={!value.size || (toggleVisible && !multiplier)} className={styles.goNext} onClick={onGoNext}>
                        Continue
                    </button>
                </div>
            </div>
        </div>
    )
}
